import { FooterService } from '@footer/services/footer.service';
import { ServiceLocator } from '@base/constants/service-locator';
import { Component, OnInit, Renderer2, ElementRef, Inject } from '@angular/core';
import { BaseComponent } from '@base/component/base.component';
import { HeaderService } from './header.service';
import { NavigationPage } from './header.model';
import { NavigationEnd, RouterEvent, NavigationStart} from '@angular/router';
import { ProfileService } from '@profile/service/profile.service';
import { Subject, Subscription } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { FooterData } from '@footer/model/footer.model';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { DOCUMENT } from '@angular/common';
declare var $: any;

@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.css'],
	animations: [
		trigger('fadeInOut', [
		  state('void', style({
			opacity: 0
		  })),
		  state('*', style({
			opacity: 1
		  })),
		  transition(':enter', animate('300ms ease-in')),
		  transition(':leave', animate('300ms ease-out'))
		])
	]
})

export class HeaderComponent extends BaseComponent implements OnInit {
	private destroyed$ = new Subject();
	private profileImgSubscription: Subscription;
	navigationData: NavigationPage[];
	profile: any = null;
	activePath: string;
	refereshToken: {};
	logo: string;
	isLoading: boolean = false;
	headerColor: string = this.router.url.includes('/season/') || this.router.url.includes('/video/')
		? '#180227'
		: '#18022780';

	profileService: ProfileService;
	headerService: HeaderService;
	footerService: FooterService;
	inputSearchText: string = null;
	footerData: FooterData;
	showSearchByGenre: boolean = false;
	
	constructor(
			private renderer: Renderer2,
			private el: ElementRef,
			@Inject(DOCUMENT) private document: Document
		) {
		super();
		this.profileService = ServiceLocator.injector.get(ProfileService);
		this.headerService = ServiceLocator.injector.get(HeaderService);
		this.footerService = ServiceLocator.injector.get(FooterService);
		this.changeHeaderColor(window.location.pathname)
		this.router.events.subscribe((event) => {
			if (event instanceof NavigationEnd) {
			  this.changeHeaderColor(event.urlAfterRedirects);
			}
		});
	}

	async ngOnInit() {
		await this.waitForToken();

		// Hide SideMenu and SearchInputMobile when navigate
		this.router.events
			.pipe(
				filter((event: RouterEvent) => event instanceof NavigationStart),
				takeUntil(this.destroyed$),
			)
			.subscribe(() => {
				this.closeSideMenu();
				$("#searchInputContainerMobile").removeClass("show");
			});

		this.getNavigation();
		setTimeout(() => {
    	  this.getFooterGeners();
	    }, 500);

		this.headerService.setActivePath.subscribe(res => {
			if (res !== undefined && res !== '') {
				this.activePath = res;
			}
		});

		if (this.userId) {
			this.getProfile();
		}

		this.router.events.subscribe(event => {
			if (event instanceof NavigationEnd) {
				var text = event.url;

				var currentActivePath = text.replace('/', '');
				this.activePath = currentActivePath.toLowerCase();
			}
		});

		$(document).mouseup(function (e) {
			var searchSuggestion = $(".searchInputMobile");
			var searchMobile = $(".search-box-mobile");
			if (!searchMobile.is(e.target) && searchMobile.has(e.target).length === 0) {
				if (!searchSuggestion.is(e.target) && searchSuggestion.has(e.target).length === 0) {
					$(".search-box-mobile").fadeOut(500);
				}
			}
		});
		this.profileImgSubscription = this.headerService.setProfileImg.subscribe(newImageUrl => {
			if (this.profile) {
			  this.profile.picture = newImageUrl;
			}
		});
	}

	ngOnDestroy() {
		if (this.profileImgSubscription) this.profileImgSubscription.unsubscribe();
	}
	
	public getProfile(): void {
		this.profileService.getUserProfile(this.userId).subscribe(
			res => {
				if (res !== undefined) {
					this.profile = res.data[0];
				}
			},
			err => {
				console.log(err);
			}
		);
	}

	public goToLoginPage(): void {
		localStorage.setItem('videoUrl', this.router.url)
		this.router.navigate(['auth']);
	}

	public getNavigation(): void {
		const navigationObject = {
			deviceTypeId: 1,
			langaugeCode: 1
		}
		this.headerService.getNavigation(navigationObject).subscribe(
			res => {
				if (res !== undefined) {
					this.navigationData = res.data.data;
					this.logo = res.data.logo;
					if (this.logo != undefined) {
						this.footerService.reloadFooter.emit(res.data.logo);
					}
					this.footerService.reloadFooter.subscribe(res => {
					});

					for (const navigate of this.navigationData) {
						if (navigate.title.toUpperCase() === 'HOME') {
							var url = this.router.url.split('?')[0];
							if (url == '/' || url == '')
								this.router.navigate(['', navigate.title.toLowerCase()]);
							return;
						}
					}
				}
			},
			err => {
				console.log(err);
			}
		);
	}

	public getPageCategorie(navigation: NavigationPage, reset: boolean): void {
		$('#sidebar').removeClass('active');
		$('.overlay').removeClass('active');
		this.router.navigate(['', navigation.title.split(" ").join("").toLowerCase()]);
		return;
	}
	changeHeaderColor(url: string) {
		if (url.includes('/season/') || url.includes('/video/')) {
			this.headerColor = 'var(--header-color)';
		} else {
			this.headerColor = '#000000b3';
		}
	}

	onKeyDownSearchInput(event) {
		if (event.key === 'Enter') {
			this.searchAssets(event.target.value);
			$('#searchInput').val('');
			$('#searchInputMobile').val('');
			$(".search-box-mobile").hide();
		}
	}

	searchAssets(value?: string) {
		if (!value)
			value = $("#searchInput").val();

		if (!value || value.trim().length < 3) {
			this.errMessageResponse('Por favor, ingresa al menos 3 caracteres');
			return;
		}

		if (!this.router.url.includes('/search')) {
			this.headerService.setSearchPath.emit(value);
		}
		this.router.navigate(['/search', value]);
		this.toggleMobileSearchInput();
		this.closeSearchByGenre();
		this.inputSearchText = null;
	}

	public gotoCuponera(): void {
		var tenant_hidden = '32';
		var payment_type_hidden = 'ALQ';
		var url_path_hidden = 'https://live.oneplay.com/';
		var client_id_hidden = this.user.id;
		var title_hidden = 'sidebar';
		var email_hidden = this.user.emailId;
		var unit_price_hidden = 100;

		var html = '<form action="https://oneplay.com/payment-tvod" method="post" id="formHiddenCuponera" style="display:none;"><input type="hidden" id="tenant_hidden" name="tenant_hidden" value="' + tenant_hidden + '"><input type="hidden" id="payment_type_hidden" name="payment_type_hidden" value="' + payment_type_hidden + '"><input type="hidden" id="url_path_hidden" name="url_path_hidden" value="' + url_path_hidden + '"><input type="hidden" id="client_id_hidden" name="client_id_hidden" value="' + client_id_hidden + '"><input type="hidden" id="title_hidden" name="title_hidden" value="' + title_hidden + '"><input type="hidden" id="email_hidden" name="email_hidden" value="' + email_hidden + '"><input type="hidden" id="unit_price_hidden" name="unit_price_hidden" value="' + unit_price_hidden + '"><button type="submit">ADQUIRIR</button></form>';
		$("#btnCuponera").append(html);
		$("#formHiddenCuponera").submit();
	}

	public goToPlans(): void {
		var tenant_hidden = '32';
		var payment_type_hidden = 'SUB';
		var url_path_hidden = 'https://live.oneplay.com/';
		var client_id_hidden = this.user.id;
		var title_hidden = 'sidebar';
		var email_hidden = this.user.emailId;
		var unit_price_hidden = 100;

		var html = '<form action="https://oneplay.com/payment-subscription" method="post" id="formHiddenPlans" style="display:none;"><input type="hidden" id="tenant_hidden" name="tenant_hidden" value="' + tenant_hidden + '"><input type="hidden" id="payment_type_hidden" name="payment_type_hidden" value="' + payment_type_hidden + '"><input type="hidden" id="url_path_hidden" name="url_path_hidden" value="' + url_path_hidden + '"><input type="hidden" id="client_id_hidden" name="client_id_hidden" value="' + client_id_hidden + '"><input type="hidden" id="title_hidden" name="title_hidden" value="' + title_hidden + '"><input type="hidden" id="email_hidden" name="email_hidden" value="' + email_hidden + '"><input type="hidden" id="unit_price_hidden" name="unit_price_hidden" value="' + unit_price_hidden + '"><button type="submit">ADQUIRIR</button></form>';
		$("#hiddenFormContainer").append(html);
		$("#formHiddenPlans").submit();
		this.isLoading = true;
  	}

	public closeModel(): void {
		$('#sidebar').removeClass('active');
		$('.overlay').removeClass('active');
	}
	public getFooterGeners(): void {
		this.footerService.getFooterGenres().subscribe(
		  res => {
			if (res !== undefined && res.success == true) {
			  this.footerData = res;
			}
		  },
		  err => {
			console.log(err);
		  }
		);
	}
	public openGenresListing(data): void {
		this.router.navigate(['/category', data.title.split(/\s/).join('').toLowerCase(), data.path]);
		this.closeSearchByGenre();
	}

	openSideMenu() {
		$("#sideMenu").addClass("show");
		$("#sideMenuOverlay").addClass("show");
	}
	closeSideMenu() {
		$("#sideMenu").removeClass("show");
		$("#sideMenuOverlay").removeClass("show");
	}

	toggleMobileSearchInput() {
		$("#searchInputMobile").toggleClass("show");
		$("#searchButtonMobile").toggleClass("transparent");
		$("#largeLogo").toggleClass("hide");
		$("#smallLogo").toggleClass("hide");
		if ($("#searchInputMobile").hasClass("show")) {
			this.showSearchByGenre = true;
			this.renderer.setStyle(this.document.body, 'overflow', 'hidden')
			this.headerColor = '#000000';
		} else {
			this.closeSearchByGenre();
		}
	}
	closeSearchByGenre() {
		this.showSearchByGenre = false;
		this.renderer.setStyle(this.document.body, 'overflow', 'auto')
		this.changeHeaderColor(window.location.pathname);
	}

	onChangeSearchInput(e, screen: "mobile" | "desktop") {
		// Keep Mobile and Desktop inputs the same value
		if (screen === "desktop") {
			$("#searchInputMobile").val(e.target.value);
		} else {
			$("#searchInput").val(e.target.value);
		}
	}
}
